import React, { useEffect, useState } from "react";
import Base from "../../Config/Base";
import Swal from "sweetalert2";
import { DatePicker, Input, Select } from "antd";
import { API_BASE_CRM_URL } from "../../Config/Config";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";

const AddPayments = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [loading, setLoading] = useState(false);

  const [invoices, setInvoices] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);

  const [formData, setFormData] = useState({
    invoiceid: null,
    amount: "",
    paymentmode: null,
    paymentmethod: "",
    date: dayjs(),
    note: "",
    transactionid: "",
  });

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}invoice/GetInvoices`);

        const data = await response.json();

        if (data.Status) {
          setInvoices(data.ResultData);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchInvoices();
  }, []);
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}payments/GetPaymentModes`,
        );

        const data = await response.json();

        if (data.Status) {
          setPaymentModes(data.ResultData);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchPaymentModes();
  }, []);
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        invoiceid: formData.invoiceid,
        amount: Number(formData.amount),
        paymentmode: formData.paymentmode,
        paymentmethod: formData.paymentmethod,
        date: formData.date.format("YYYY-MM-DD"),
        note: formData.note,
        transactionid: formData.transactionid,
      };

      console.log(payload);

      const response = await fetch(`${API_BASE_CRM_URL}payments/AddPayment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
          timerProgressBar: true,
        });

        setTimeout(() => {
          navigate("/payments");
        }, 1500);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Failed to add payment",
        timer: 2000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Base>
        <div className="page-heade mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <div className="page-title">
              <h4>Add payments</h4>
              <p className="fw-semibold">
                Fill out the form to add a new payment
              </p>
            </div>

            <div className="">
              <Link to="/payments">
                <button className="btn btn-secondary btn-sm">
                  <i className="fa-solid fa-list"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12">
            <div className="card">
              <div className="card-body p-1">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3 p-3 ">
                    <div className="col-6">
                      <Select
                        size="large"
                        className="w-100"
                        placeholder="Select Invoice"
                        value={formData.invoiceid}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            invoiceid: value,
                          })
                        }
                        prefix={
                          <i className="fa-solid fa-file-invoice-dollar"></i>
                        }
                        options={invoices.map((item) => ({
                          value: item.id,
                          label: `INV-${item.number}`,
                        }))}
                      />
                    </div>

                    <div className="col-6">
                      <Select
                        size="large"
                        className="w-100"
                        placeholder="Payment Mode"
                        value={formData.paymentmode}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            paymentmode: value,
                          })
                        }
                        prefix={<i className="fa-solid fa-credit-card"></i>}
                        options={paymentModes.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                      />
                    </div>

                    <div className="col-6">
                      <Input
                        size="large"
                        placeholder="Amount"
                        prefix={
                          <i className="fa-solid fa-indian-rupee-sign"></i>
                        }
                        value={formData.amount}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            amount: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-6">
                      <Input
                        size="large"
                        placeholder="Payment Method"
                        prefix={<i className="fa-solid fa-money-bill-wave"></i>}
                        value={formData.paymentmethod}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            paymentmethod: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-6">
                      <DatePicker
                        size="large"
                        className="w-100"
                        format="DD-MM-YYYY"
                        value={formData.date}
                        placeholder="Payment Date"
                        suffixIcon={
                          <i className="fa-solid fa-calendar-days"></i>
                        }
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            date: value,
                          })
                        }
                      />
                    </div>

                    <div className="col-6">
                      <Input
                        size="large"
                        placeholder="Transaction ID"
                        prefix={<i className="fa-solid fa-fingerprint"></i>}
                        value={formData.transactionid}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            transactionid: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-12">
                      <Input.TextArea
                        rows={4}
                        placeholder="Payment Note"
                        value={formData.note}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            note: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2">
            {/* Cancel */}
            <div
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  color: "#dc3545",
                  fontSize: "16px",
                }}
              />
            </div>

            {/* Save */}
            <div
              onClick={handleSubmit}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className={`fa-solid ${
                  loading ? "fa-spinner fa-spin" : "fa-check"
                }`}
                style={{
                  color: "#198754",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
        </div>

        <Footer></Footer>
      </Base>
    </>
  );
};

export default AddPayments;
